// eslint-disable-next-line import/no-default-export
export default {
  Generic: {
    Error: 'Unexpected Error',
    Message: 'There was a service error.'
  }
};
